import {
  arrayOf,
  bool,
  node,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from 'prop-types'

export const threadTopicType = {
  type: string,
  value: string,
}

export const threadItemPropTypes = {
  id: string.isRequired,
  title: string.isRequired,
  url: string.isRequired,
  topic: shape(threadTopicType),
  messagesCount: number.isRequired,
  sellerName: string.isRequired,
  orderNumber: string,
  lastMessageTimestamp: string.isRequired,
  isActive: bool.isRequired,
}

export const attachmentType = {
  id: string.isRequired,
  name: string.isRequired,
  size: number,
}

export const threadOrganizationDetailsType = {
  id: string,
  type: string,
  displayName: string,
}

export const threadSubjectType = {
  code: string.isRequired,
  label: string.isRequired,
}

export const messageThreadParticipantType = {
  id: string,
  type: oneOf<string>([
    'CUSTOMER',
    'CUSTOMER_USER',
    'OPERATOR',
    'OPERATOR_USER',
    'SHOP',
    'SHOP_USER',
  ]),
  displayName: string,
  organizationDetails: shape(threadOrganizationDetailsType),
}

export const messageType = {
  id: string.isRequired,
  body: oneOfType([string, node]).isRequired,
  dateCreated: string.isRequired,
  from: shape(messageThreadParticipantType).isRequired,
  to: arrayOf(shape(messageThreadParticipantType)).isRequired,
  attachments: arrayOf(shape(attachmentType)),
}

export const threadsListType = {
  data: arrayOf(shape(threadItemPropTypes)),
  nextPageToken: string,
  prevPageToken: string,
}
